export default [
  {
    path: "/signup/business",
    component: () => import("@/views/business/signup/BusinessSignUpView.vue"),
  },
  {
    path: "/signup/business/success",
    component: () => import("@/views/business/signup/BusinessSignUpSuccessView.vue"),
  },
  {
    path: "/signup",
    component: () => import("@/views/business/signup/BusinessSignUpView.vue"),
  },
];
